
const ComplaintsLoading = ['$resource', function ($resource) {
    return $resource(API_URL + '/api/1.0/masters/complaints/');
}]

const ComplaintsMaster = ['$q', 'ComplaintsLoading',  function ($q, ComplaintsLoading) {

    var complaints= {
        items: null,

        loadComplaints: function () {
            var self = this;
            var deferred = $q.defer();
            if (this.items == null)
                ComplaintsLoading.query({status: "CRE"}, function (data) {
                    self.items = data;
                    deferred.resolve(data);
                });
            else
                deferred.resolve(self.items);

            return deferred.promise;
        }

    };

    return complaints;


}]


export {ComplaintsMaster, ComplaintsLoading}
